import React from 'react';

import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TypographyList,
  makeStyles,
  TypographyListItem,
  Typography,
} from '@gogame/components';

import { OsVersion } from './OsVersion';

const useStyles = makeStyles({
  deviceType: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: 250,
  },
});
export const FraudProtection = ({ fraudProtections }) => {
  const classes = useStyles();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>Countries</TableCell>
            <TableCell>Device type</TableCell>
            <TableCell>OS version</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fraudProtections?.map(
            ({ type, deviceType, countries, osVersion }) => {
              return (
                <TableRow>
                  <TableCell>{type?.name}</TableCell>
                  <TableCell>
                    <TypographyList
                      gutter={0}
                      limit={1}
                      data={countries}
                      ellipsis={true}
                    >
                      {countries?.map((c) => (
                        <TypographyListItem>{c.name}</TypographyListItem>
                      ))}
                    </TypographyList>
                  </TableCell>
                  <TableCell>
                    {deviceType && (
                      <Typography
                        ellipsis={true}
                        className={classes.deviceType}
                      >
                        {deviceType?.name}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <OsVersion {...osVersion} />
                  </TableCell>
                </TableRow>
              );
            }
          )}
          {/*{registrationsFraud ? (*/}
          {/*  <TableRow>*/}
          {/*    <TableCell>Check registrations</TableCell>*/}
          {/*    <TableCell>*/}
          {/*      <LegacyTextList*/}
          {/*        gutter={0}*/}
          {/*        limit={1}*/}
          {/*        count={registrationsFraud?.countries?.length}*/}
          {/*        data={registrationsFraud?.countries}*/}
          {/*        ellipsis={true}*/}
          {/*      />*/}
          {/*    </TableCell>*/}
          {/*    <TableCell></TableCell>*/}
          {/*    <TableCell>*/}
          {/*      <OsVersion {...registrationsFraud?.osVersion} />*/}
          {/*    </TableCell>*/}
          {/*  </TableRow>*/}
          {/*) : null}*/}
          {/*{installFraud ? (*/}
          {/*  <TableRow>*/}
          {/*    <TableCell>Check installs</TableCell>*/}
          {/*    <TableCell>*/}
          {/*      <TypographyList limit={1}>*/}
          {/*        {installFraud.countries?.map(({ name }) => (*/}
          {/*          <TypographyListItem>{name}</TypographyListItem>*/}
          {/*        ))}*/}
          {/*      </TypographyList>*/}
          {/*    </TableCell>*/}
          {/*    <TableCell>*/}
          {/*      <Typography ellipsis={true} className={classes.deviceType}>*/}
          {/*        {installFraud?.deviceType?.name}*/}
          {/*      </Typography>*/}
          {/*    </TableCell>*/}
          {/*    <TableCell>*/}
          {/*      <OsVersion {...installFraud?.osVersion} />*/}
          {/*    </TableCell>*/}
          {/*  </TableRow>*/}
          {/*) : null}*/}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
